<template>
  <div>
    <div class="d-flex align-center mb-3">
      <h3>Task Templates</h3>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="openCreate">
        <v-icon left>mdi-plus</v-icon>
        New Template
      </v-btn>
    </div>

    <v-data-table :items="templates" :headers="headers" :search="search">
      <template v-slot:top>
        <v-text-field
          v-model="search"
          label="Search templates..."
          prepend-inner-icon="mdi-magnify"
          clearable
          dense
          outlined
          class="mb-2"
        ></v-text-field>
      </template>

      <template v-slot:item.default_priority="{ item }">
        <v-chip :color="priorityColor(item.default_priority)" small dark>
          {{ priorityLabel(item.default_priority) }}
        </v-chip>
      </template>

      <template v-slot:item.default_recurrence_type="{ item }">
        {{ recurrenceLabel(item.default_recurrence_type) }}
      </template>

      <template v-slot:item.is_active="{ item }">
        <v-chip :color="item.is_active ? 'green' : 'grey'" small dark>
          {{ item.is_active ? "Active" : "Inactive" }}
        </v-chip>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn icon small color="primary" @click="openEdit(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon small color="error" @click="del(item)">
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <task-template-dialog
      v-model="showDialog"
      :editTemplate="editingTemplate"
      @saved="onSaved"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TaskTemplateDialog from "./TaskTemplateDialog.vue";

export default {
  components: { TaskTemplateDialog },
  data() {
    return {
      search: "",
      showDialog: false,
      editingTemplate: null,
      headers: [
        { text: "Name", value: "name" },
        { text: "Category", value: "category", width: "130" },
        { text: "Priority", value: "default_priority", width: "120" },
        { text: "Recurrence", value: "default_recurrence_type", width: "120" },
        { text: "Status", value: "is_active", width: "100" },
        { text: "Actions", value: "actions", sortable: false, width: "110" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      templates: "task_template/templates",
    }),
  },
  created() {
    this.get_templates();
  },
  methods: {
    ...mapActions({
      get_templates: "task_template/get_templates",
      delete_template: "task_template/delete_template",
    }),
    priorityColor(p) {
      return p === "very_urgent" ? "red" : p === "urgent" ? "orange" : "blue";
    },
    priorityLabel(p) {
      return p === "very_urgent"
        ? "Very Urgent"
        : p === "urgent"
        ? "Urgent"
        : "Basic";
    },
    recurrenceLabel(r) {
      const map = {
        none: "One-Time",
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
      };
      return map[r] || r;
    },
    openCreate() {
      this.editingTemplate = null;
      this.showDialog = true;
    },
    openEdit(item) {
      this.editingTemplate = item;
      this.showDialog = true;
    },
    async del(item) {
      if (
        await this.$confirm({
          title: "Deactivate Template",
          message: "Deactivate this template?",
          color: "orange",
          icon: "mdi-alert",
        })
      ) {
        this.delete_template(item.id);
      }
    },
    onSaved() {
      this.get_templates();
    },
  },
};
</script>
